import OptionsTileList from './OptionsTileList'

export * from './OptionsTileList'
export default OptionsTileList
